import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Signal } from 'src/app/shared/model/signal';
import { AlertService } from 'src/app/shared/services/alert.service';
import { WorldWatchService } from 'src/app/shared/services/worldwatch.service';
import { OktaAuthService } from '../../../app.service';
import { environment } from 'src/environments/environment';
import { ItsmService } from 'src/app/shared/services/itsm.service';
import { SupportCaseSearchCriteria } from 'src/app/shared/model/searchCriteria';
import { UserActivityService } from 'src/app/shared/services/user-activity.service';
import { ACTIONS, PAGES, TYPES } from 'src/app/shared/constants';

@Component({
  selector: 'app-viewsignal',
  templateUrl: './viewsignal.component.html',
  styleUrls: ['./viewsignal.component.scss']
})
export class ViewSignalComponent implements OnInit {

  signalRef: string;
  signal: Signal;
  loadingSignal: boolean;
  worldWatchGroup = environment.world_watch_group;
  isWorldWatchUser: boolean;
  haveTicket = false;

  constructor(
    private route: ActivatedRoute,
    private worldwatchService: WorldWatchService,
    private alertService: AlertService,
    private oktaAuthService: OktaAuthService,
    private itsmService: ItsmService,
    private userActivity: UserActivityService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.signalRef = params.signalRef;
      this.fetchTickets(params.signalRef);
    });

    this.loadingSignal = true;


      if(this.oktaAuthService.userDetails.groups.indexOf(this.worldWatchGroup) > -1) {

        this.isWorldWatchUser = true;
        this.worldwatchService.signal(this.signalRef).then(res => {
          this.signal = res;
          this.loadingSignal = false;
        })
        .catch(err => {
          this.loadingSignal = false;
          this.alertService.handlerError(err);
        });
      } else {
        // if the user doesn't have worldwatch role
        this.loadingSignal = false;
        this.isWorldWatchUser = false;
      }


    this.userActivity.logActivity(TYPES.resources, PAGES.viewSignal, ACTIONS.visit);
  }

  likeSignal(): void {
    this.worldwatchService.signalLike(this.signalRef)
      .then(res => {
        this.signal.likeCount++;
      })
      .catch(err => {
        this.alertService.handlerError(err);
      });
  }

  downloadPDF(): void {
    this.worldwatchService.signalPDF(this.signalRef)
      .subscribe(val => {
        const file = new Blob([val], {type: 'application/pdf'});
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(file);
        }else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
    })
    .catch(err => {
      console.log('Error downloading the file ', err);
    });
  }

  fetchTickets(signalRef){
    const searchCritera = new SupportCaseSearchCriteria();
    searchCritera.worldWatchSignal = signalRef.split('-')[1];
    this.itsmService.caseSearch(searchCritera)
          .then(res => {
            if(res.length > 0 ){
              this.haveTicket = true;
            }
          })
          .catch(err => {
            console.log(err);
          });
  }
}
